import React from 'react';
import { ProviderProps } from '@app/shell/types';
import ReqContext from '../state/ReqContext';

/**
 * We use memo here to ensure it runs on the server and client.
 *
 * @param children
 * @param req
 * @constructor
 */
const RequestProvider = ({ children, req = undefined }: ProviderProps) => (
  <ReqContext.Provider value={req}>{children}</ReqContext.Provider>
);

export default RequestProvider;
